// General
import React, { useState, useContext, useRef } from "react";

// Context
import { WarehouseContext } from "../data/warehouse/WarehouseContext";
import { useData } from "../data/general/DataContext";

// Core Components
import TablePage from "../core/TablePage";

// Modals
import WarehouseAddModal from "../modals/warehouse/WarehouseAddModal";
import WarehouseUpdateModal from "../modals/warehouse/WarehouseUpdateModal";

// PrimeReact Components
import { Button } from "primereact/button";
import { OverlayPanel } from "primereact/overlaypanel";

// Icons
import { FaTrash, FaPencilAlt } from "react-icons/fa";

const WarehousePage = () => {
  // Contextten depolar ve işlemler
  const { warehouses, addWarehouse, updateWarehouse, deleteWarehouse } = useContext(WarehouseContext);
  const { windowMode } = useData();

  // Modal ve seçili depo state'leri
  const [showAddModal, setShowAddModal] = useState(false);
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [selectedWarehouse, setSelectedWarehouse] = useState(null);

  const ActionMenu = ({ rowData }) => {
    const op = useRef(null);
    if (windowMode === "mobile") return null;

    return (
      <>
        <Button
          label=". . ."
          className="p-button-rounded p-button-text"
          style={{ minWidth: "40px", fontSize: "22px", fontWeight: "bold" }}
          onClick={(e) => op.current.toggle(e)}
        />
        <OverlayPanel ref={op} dismissable showCloseIcon={false} style={{ padding: "0.5rem" }}>
          <div className="flex flex-col gap-0 p-2 w-32">
            {/* Düzenle */}
            <Button
              icon={<FaPencilAlt />}
              label="Düzenle"
              className="p-button-text w-full justify-start"
              style={{ fontSize: "14px", gap: "10px" }}
              onClick={() => {
                setSelectedWarehouse(rowData);
                setShowUpdateModal(true);
                op.current.hide();
              }}
            />
            <div className="w-full border-t border-gray-300 my-1"></div>
            {/* Sil */}
            <Button
              icon={<FaTrash />}
              label="Sil"
              className="p-button-text w-full justify-start"
              style={{ color: "red", fontSize: "14px", gap: "10px" }}
              onClick={() => {
                deleteWarehouse(rowData.id);
                op.current.hide();
              }}
            />
          </div>
        </OverlayPanel>
      </>
    );
  };

  // Kolonlar
  const columns = [
    { field: "id", header: "ID", hideInFilter: true },
    { field: "name", header: "Depo Adı" },
    { field: "location", header: "Lokasyon" },
    { field: "status", header: "Durum" },
    {
      header: "İşlemler",
      body: (rowData) =>
        windowMode === "mobile" ? (
          // Mobil görünümde direkt butonlar
          <div className="flex gap-2 mt-2 w-full">
            <Button
              icon={<FaPencilAlt />}
              label="Düzenle"
              className="flex-1"
              style={{
                backgroundColor: "#3b82f6",
                color: "white",
                border: "none",
                borderRadius: "6px",
                height: "26px",
                fontSize: "10px",
                justifyContent: "center",
                gap: "4px",
                padding: "0 6px",
              }}
              onClick={() => {
                setSelectedWarehouse(rowData);
                setShowUpdateModal(true);
              }}
            />
            <Button
              icon={<FaTrash />}
              label="Sil"
              className="flex-1"
              style={{
                backgroundColor: "#ef4444",
                color: "white",
                border: "none",
                borderRadius: "6px",
                height: "26px",
                fontSize: "10px",
                justifyContent: "center",
                gap: "4px",
                padding: "0 6px",
              }}
              onClick={() => deleteWarehouse(rowData.id)}
            />
          </div>
        ) : (
          <ActionMenu rowData={rowData} />
        ),
      hideInFilter: true,
    },
  ];

  // Kolon stilleri
  const enhancedColumns = columns.map((col) =>
    col.field === "id"
      ? { ...col, style: { width: "60px", padding: "0 12px" } }
      : { ...col, style: { padding: "0 12px" } }
  );

  // Kolon filtreleme seçenekleri
  const columnFilterOptions = {
    name: { type: "text" },
    location: { type: "autocomplete", options: Array.from(new Set(warehouses.map(w => w.location))).filter(Boolean) },
    status: { type: "checkbox", options: Array.from(new Set(warehouses.map(w => w.status))).filter(Boolean) },
  };

  return (
    <>
      <div className="p-6">
        <TablePage
          title="Depo Listesi"
          subTitle="Depo ekleyebilir, düzenleyebilir veya silebilirsiniz."
          columns={enhancedColumns}
          data={warehouses}
          defaultRows={10}
          rowsPerPageOptions={[10, 15, 25, 50,100]}
          showSearch
          onAdd={() => setShowAddModal(true)}
          columnFilterOptions={columnFilterOptions}
        />
      </div>

      {/* Ekleme ve Güncelleme Modalları */}
      <WarehouseAddModal
        show={showAddModal}
        handleClose={() => setShowAddModal(false)}
        onSubmit={(warehouse) => addWarehouse(warehouse)}
      />

      <WarehouseUpdateModal
        show={showUpdateModal}
        handleClose={() => setShowUpdateModal(false)}
        warehouse={selectedWarehouse}
      />
    </>
  );
};

export default WarehousePage;
